import { DeterministicView } from '@bingads-webui/deterministic-view';
import titledContentTemplate from '../template/contents/titled.pug';

/** The View class of title content */
export class TitledContent extends DeterministicView {
  get template() {
    return titledContentTemplate;
  }
  /**
   * Set popover's title
   * @param {Object} title set popover's title: it could be a DeterministicView or a template.
   * @returns {TitledContent} - The view itself
   */
  setTitle(title) {
    if (title instanceof DeterministicView) {
      this.setChild('title', title);
      return this.setState({ title: { isView: true } });
    }

    return this.setState({ title });
  }
  /**
   * Set popover's body
   * @param {Object} body set popover's body: it could be a DeterministicView or a template.
   * @returns {TitledContent} - The view itself
   */
  setBody(body) {
    if (body instanceof DeterministicView) {
      this.setChild('body', body);
      return this.setState({ body: { isView: true } });
    }

    return this.setState({ body });
  }
}
